const IconSuffixRegex = /(Solid|Light)$/;
export function IconNameWithoutSuffix(iconTpe) {
    return iconTpe.replace(IconSuffixRegex, () => "");
}
const iconTypes = {
    MinimizeButton: ['fal', 'minus'],
    CloseButton: ['fal', 'times'],
    SendIcon: ['fas', 'paper-plane'],
    ExternalLinkIcon: ['fal', 'external-link'],
    ThumbUpIconSolid: ['fas', 'thumbs-up'],
    ThumbUpIconLight: ['fal', 'thumbs-up'],
    ThumbDownIconSolid: ['fas', 'thumbs-down'],
    ThumbDownIconLight: ['fal', 'thumbs-down'],
    CommentIcon: ['fas', 'comment-alt-lines'],
    OldScrollIcon: ['fas', 'scroll-old'],
    ChevronRight: ['far', 'chevron-right'],
    ChevronLeft: ['far', 'chevron-left'],
    ChevronUp: ['far', 'chevron-up'],
    ChevronDown: ['far', 'chevron-down'],
    ArrowLeft: ['fal', 'arrow-left'],
    ArrowRight: ['fal', 'arrow-right'],
};
export default iconTypes;
